import { DisplayData, TenantOrderLine } from '~/lib/model';
import Big from 'big.js';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { DeliverableType } from '~common/model/Deliverable';
import MpiFloorplanConfig from './MpiFloorplanConfig';
import MpiJob from '../../model/MpiJob';
import { PersonaType } from '~/tenants/common/TenantPersona';

const MPI_FLOOR_PLAN_MIN_SQFT = 1000;
const MPI_FLOOR_PLAN_MIN_AMOUNT = 100;
const MPI_FLOOR_PLAN_SQFT_MULTIPLIER = 0.025;

export default class MpiFloorplanJob extends MpiJob<typeof MpiFloorplanConfig> {
  defaultValue(): ZodVersionedMetadata<(typeof MpiFloorplanConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
    };
  }

  onsite() {
    return 30;
  }

  get deliverable(): DeliverableType {
    return DeliverableType.FLOORPLAN;
  }

  get media() {
    return PersonaType.OFFICE;
  }

  get performable() {
    return MpiFloorplanConfig;
  }

  info(): DisplayData[] {
    const info = super.info();

    return info;
  }

  expenseLines(): TenantOrderLine[] {
    const lines = super.expenseLines();

    return lines;
  }

  revenueLines(): TenantOrderLine[] {
    const lines = super.revenueLines();

    const hasPhotos = this.order.jobs.some(j => j.performable_id === 'photos');
    const baseRate = new Big(hasPhotos ? '95' : '125');
    const pricePerSqft = hasPhotos ? '0.016' : '0.02';
    const sqftPrice = new Big(Math.max(0, this.order.metadata.sqft - 2000)).round(0, 0).times(pricePerSqft);

    lines.push({
      amount: baseRate.plus(sqftPrice),
      description: `2D Floorplan`,
      id: 'floorplan',
    });

    return lines;
  }
}
